import { invoke } from 'lodash/fp';

import {
  get,
  getDatabase,
  ref,
} from 'firebase/database';

import { app } from './initializeApp';
import { getUid } from './getUid';

export const waterGet = async date_int =>
{
  const uid = await getUid();

  return get(ref(getDatabase(app), `fatsecret/${ uid }/water/${ date_int }`))
  .then(invoke('val'));
};